'use strict';
import Base  from './ForgotPasswordBase';
import Render  from './ForgotPasswordRender';

export default class ForgotPassword extends Base {
    render() {
        return Render.call(this, this.props, this.state);
    }
}
